define('dataSource/logout',['jquery', 'atn/atn'], function($, atn) {
	'use strict';
	return {
		logout: logout
	};

	function logout() {
		var deferred = $.Deferred();
		$.ajax({
            url: atn.config.api.sessionData,
            type: 'DELETE',
            global: false
        }).done(function(response) {
			deferred.resolve(response);
		}).fail(function(xhr) {
			if (xhr.status === 406) {
				deferred.resolve(xhr.responseJSON);
			} else{
				deferred.reject(xhr);
			}
		});
		return deferred.promise();
	}
});
